import { LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAILURE } from '../Utils/Constants';

export const logout = (payload) => {
    return {
        type: LOGOUT,
        payload: payload
    }
}

export const logoutFailure = (payload) => {
    return {
        type: LOGOUT_FAILURE,
        payload: payload
    }
}

export const logoutSuccess = (payload) => {
    return {
        type: LOGOUT_SUCCESS,
        payload: payload
    }
}
